import { LoadState } from '@util/types'
import { createFavoritesAPIClient, createRecommendationsAPIClient } from '@/api/MyGeoAPIClientFactory'
import { createStationAPIClient } from '@/api/StationAPIClientFactory'
import { Base } from '@/generated-clients/myGeo'
import { StationMapping } from '@/generated-clients/termine'

const favoritesApiClient = createFavoritesAPIClient()
const stationApiClient = createStationAPIClient()
const recommendationsApiClient = createRecommendationsAPIClient()

function createState () {
  return {
    activeBase: { // "Mein Stützpunkt"
      status: LoadState.None,
      response: null as Base | null
    },

    recommendedBase: {
      status: LoadState.None,
      response: null as Base | null
    },

    stations: { // alle Stützpunkte
      status: LoadState.None,
      response: [] as StationMapping[]
    }
  }
}

export default {
  namespaced: true,
  state: createState,
  mutations: {
    ACTIVE_BASE_REQUEST (state) {
      state.activeBase.status = LoadState.Loading
    },
    ACTIVE_BASE_RESPONSE (state, payload) {
      state.activeBase.status = LoadState.Success
      state.activeBase.response = payload
    },
    ACTIVE_BASE_ERROR_RESPONSE (state, payload) {
      state.activeBase.status = LoadState.Error
      state.activeBase.response = payload
    },
    STATIONS_REQUEST (state) {
      state.stations.status = LoadState.Loading
    },
    STATIONS_RESPONSE (state, payload) {
      state.stations.status = LoadState.Success
      state.stations.response = payload
    },
    STATIONS_ERROR_RESPONSE (state, payload) {
      state.stations.status = LoadState.Error
      state.stations.response = payload
    },
    RECOMMENDED_BASE_REQUEST (state) {
      state.recommendedBase.status = LoadState.Loading
    },
    RECOMMENDED_BASE_RESPONSE (state, payload) {
      state.recommendedBase.status = LoadState.Success
      state.recommendedBase.response = payload
    },
    RECOMMENDED_BASE_ERROR_RESPONSE (state, payload) {
      state.recommendedBase.status = LoadState.Error
      state.recommendedBase.response = payload
    },
  },
  actions: {
    async fetchActiveOeamtcBase ({ commit }) {
      commit('ACTIVE_BASE_REQUEST')
      try {
        const response = await favoritesApiClient.getActiveOeamtcBase()
        commit('ACTIVE_BASE_RESPONSE', response.data)
        return response.data
      } catch (e) {
        commit('ACTIVE_BASE_ERROR_RESPONSE', e.response)
        throw e
      }
    },

    async fetchRecommendedBase ({commit}, { lat, lon }) {
      try {
        commit('RECOMMENDED_BASE_REQUEST')
        const response = await recommendationsApiClient.recommendBaseForUser(lat, lon)
        commit('RECOMMENDED_BASE_RESPONSE', response.data)
        return response.data
      } catch (e) {
        commit('RECOMMENDED_BASE_ERROR_RESPONSE', e.response)
        throw e
      }
    },

    async fetchStations ({ commit }) {
      try {
        commit('STATIONS_REQUEST')
        const response = await stationApiClient.getStationMappings()
        commit('STATIONS_RESPONSE', response.data)
        return response.data
      } catch (e) {
        commit('STATIONS_ERROR_RESPONSE', e.response)
        throw e
      }
    },
  },
  getters: {
    getActiveBase: state => state.activeBase.response,
    getActiveBaseStatus: state => state.activeBase.status,
    getStations: state => state.stations.response,
    getStationsStatus: state => state.stations.status,
    getRecommendedBase: state => state.recommendedBase.response,
    getRecommendedBaseStatus: state => state.recommendedBase.status,
    getSlugifiedBaseName: state => (baseName: string) => {
      const stationMapping = state.stations.response.find(mapping => mapping.bezeichnung === baseName)
      return stationMapping?.slug || ''
    }
  },
}

